import { render, staticRenderFns } from "./Auswertung.vue?vue&type=template&id=10f37cb6"
import script from "./Auswertung.vue?vue&type=script&lang=js"
export * from "./Auswertung.vue?vue&type=script&lang=js"
import style0 from "./Auswertung.vue?vue&type=style&index=0&id=10f37cb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports